import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {header} from "./header";
import {pollsView_template} from "../components/templates/pollsView_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {PollFormatter} from "../utils/PollFormatter";

declare var ko: any;
declare var page: any;

export class polls_view extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected exportCSVxhr : XMLHttpRequestHandler;
    protected pollsView: pollsView_template;
    protected pollData: any = null;

    protected getModuleName(){

        return "polls_view";
    }

    buildContent() : Array<Element>{

        // create validation errors list template
        this.pollsView = new pollsView_template("editForm", this.viewModel, this);

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("View Poll");

        return [this.pollsView.build()];
    }

    protected getMemoryViewModel(){
        let templateViewModel = this.pollsView.getTemplateViewModel();

        //delete templateViewModel.Job;

        return templateViewModel;
    }

    public fillPage() : void{

        let brandId = this.getBrandId();
        this.pollsView.setBrandId(brandId);

        this.getReferences();
    }

    protected getReferences() {

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
        this.loadingIn(this.pollsView.builtTemplate);

        let usrReq_url: string = `/api/polls/references`;
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onReferencesRequestReturn;
        this.XHRHdl.execute();
    }

    protected onReferencesRequestReturn(req, obj){


        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                obj.setReferences(responseParsed);
                obj.getData();
            });
        }
    }

    protected getData(){

        let id: number | string = 0;
        let pathId = this.getVnAppZone().app.params.id;
        if (pathId !== undefined && !isNaN(pathId)) {
            this.pollsView.setId(pathId);
            id = pathId;
        }

        let brandId = this.getBrandId();

        let usrReq_url: string = `/api/brand/${brandId}/polls/get/${id}`;
        let usrReq_params: Array<Array<string>> = [];

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onGetRequestReturn;
        this.XHRHdl.execute();
    }

    protected onGetRequestReturn(req, obj){


        return function(){
            obj.manageResponse(req, obj, function(){

                try {
                    let responseParsed = JSON.parse(req.request.response);
                    obj.updateList(responseParsed.data);
                } finally {
                    obj.loadingOut(obj.pollsView.builtTemplate);
                }
            });
        }
    }

    protected updateList(data){

        const poll = PollFormatter.formatForView(data, this.getBrandId());
        this.pollData = data;
        this.pollsView.setId(poll.id);
        this.pollsView.setName(poll.name);
        this.pollsView.setDescription(poll.description);
        this.pollsView.setDateClosed(poll.dateClosed);
        this.pollsView.setDateCreated(poll.dateCreated);
        this.pollsView.setBrandResults(poll.questions, poll.brandResults);
        this.pollsView.setDiscussionArticleTitle(poll.discussionArticleTitle);
        if (poll.idReferenceArticle) {
            this.pollsView.setReferenceBrandId(poll.idReferenceBrand);
            this.pollsView.setReferenceArticle(poll.referenceArticle);
        }
    }

    protected formatChoices(questions){
        return PollFormatter.formatChoices(questions);
    }

    protected edit(id, brandId) {

        page.redirect(`/brand/${brandId}/categorization/polls/edit/${id}`);
    }

    protected setReferences(references) {
        this.pollsView.setBrandReferences(references.brands);
    }

    protected cancel(id, brandId) {
         this.releaseLock(id, brandId);
         page.redirect(`/brand/${brandId}/categorization/polls/`);
    }

    protected releaseLock(id, brandId) {
        // request a lock release
        let usrReq_url: string = `/api/brand/${brandId}/polls/release/${id}`;
        let usrReq_params: Array<Array<string>> = [];

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdl.execute();
    }

    public getBrandId() {
        return this.getVnAppZone().app.params.idBrand;
    }

    protected exportPoll() {

        if (this.exportCSVxhr) {
            this.exportCSVxhr.cancelAndReset();
        }

        let brandId = this.getBrandId();
        this.pollsView.setBrandId(brandId);
        const pollId = this.pollsView.getId();
        const cleanFilters = ko.toJS({
            selectedBrandId: this.pollsView.getSelectionBrandId()
        });

        let url: string = `/api/brand/${brandId}/polls/export/${pollId}/`;

        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(cleanFilters)]);
        this.exportCSVxhr = new XMLHttpRequestHandler(url, usrReq_params, this);
        this.exportCSVxhr.mode = XMLHttpRequestHandler_requestType.POST;
        this.exportCSVxhr.onReadyStateFunction = this.onExportListReturn;
        this.exportCSVxhr.execute();
    }

    protected onExportListReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let csvContent = req.request.response;
                if (csvContent) {
                    obj.triggerCSVDownload(csvContent);
                    obj.sendNotification("CSV export done successfully");
                } else {
                    obj.sendNotification("No data to download", 'alert');
                }

                obj.pollsView.asExportInProgress(false);
                obj.pollsView.setExportTextBox("Export to CSV");
            });
        }
    }

    private sendNotification(message : string = 'Export CSV', type : 'success' | 'alert' | 'error' = 'success') {
        this.getVnAppZone().notification = new vn_app_zone_notification(type, message);
        this.getVnAppZone().showNotificationToModule();
    }


    private triggerCSVDownload(csvContent: string) {
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');

        const today = new Date();
        const year = today.getFullYear();
        const month = ('0' + (today.getMonth() + 1)).slice(-2);
        const day = ('0' + today.getDate()).slice(-2);
        const dateStr = `${year}-${month}-${day}`;

        const pollId = this.pollsView.getId();
        const pollName = this.pollsView.getName();
        const brandName = this.pollsView.getCurrentBrandName();

        a.href = url;
        a.download = `${pollName} (${pollId}) ${brandName} Poll Data ${dateStr}.csv`;
        document.body.appendChild(a);
        a.click();

        a.remove();
        URL.revokeObjectURL(url);
    }

    public filterDropdownOnChange(idElement) {

        this.pollsView.handleBrandChange(idElement);
    }

    protected getArticlesSuggestion(keyword, idElement) {
        const params = [["data", ko.toJSON({list: {keyword, sourceId: idElement}})]];
        const request = new XMLHttpRequestHandler(`/api/brand/${this.getBrandId()}/polls/article-suggestions/`, params, this);
        request.onReadyStateFunction = (req, obj) => () => obj.manageResponse(req, obj, () => obj.pollsView.setArticleOptions(JSON.parse(req.request.response).data.articles));
        request.execute();
    }

    protected filterSimpleOnChange(idElement) { }

    protected generateBasedOnArticle() {
        const articleId = this.pollsView.getReferenceArticleId();
        if (!articleId) return;

        this.loadingIn(this.pollsView.builtTemplate);
        const payload = {
            idPoll: this.pollsView.getId(),
            idReferenceArticle: articleId,
            idReferenceBrand: this.pollsView.getReferenceBrandId(),
        };
        const request = new XMLHttpRequestHandler(`/api/brand/${this.getBrandId()}/polls/generate-from-article/`, [["data", ko.toJSON(payload)]], this);
        request.mode = XMLHttpRequestHandler_requestType.POST;
        request.onReadyStateFunction = (req, obj) => () => {
            if (req.request.readyState != 4) {
                return;
            }

            if (req.request.status < 200 || req.request.status >= 300) {
                let message = 'Poll generation failed. Please try again.';
                try {
                    const responseParsed = JSON.parse(req.request.response || '{}');
                    message = responseParsed.message || responseParsed.error || message;
                } catch (e) {}
                obj.sendNotification(message, 'error');
                obj.loadingOut(obj.pollsView.builtTemplate);
                return;
            }

            try {
                obj.manageResponse(req, obj, () => {
                    const responseData = JSON.parse(req.request.response).data;
                    obj.pollsView.setQuestions(responseData.questions || []);
                    obj.pollsView.setReferenceBrandId(responseData.idReferenceBrand);
                    obj.pollsView.setReferenceArticle(responseData.referenceArticle);
                    obj.sendNotification('Poll generated from article.');
                });
            } finally {
                obj.loadingOut(obj.pollsView.builtTemplate);
            }
        };
        request.execute();
    }

    protected saveGeneratedPoll(responseData) {
        const activeBrandIds = (this.pollData && this.pollData.brandResults ? this.pollData.brandResults : [])
            .filter((brandResult) => brandResult.isActive)
            .map((brandResult) => brandResult.idBrand);
        const payload = {
            id: this.pollsView.getId(),
            name: this.pollsView.getName(),
            questions: this.pollsView.getQuestions(),
            dateClosed: this.pollData ? this.pollData.dateClosed : null,
            brands: activeBrandIds,
            idReferenceArticle: responseData.idReferenceArticle,
            idReferenceBrand: responseData.idReferenceBrand,
        };

        const request = new XMLHttpRequestHandler(`/api/brand/${this.getBrandId()}/polls/save/`, [["data", ko.toJSON(payload)]], this);
        request.mode = XMLHttpRequestHandler_requestType.POST;
        request.execute();
    }

    public setBrandResults(networkResult, brandResults) {

        const poll = PollFormatter.formatForView({
            questions: networkResult,
            brandResults: brandResults,
        }, this.getBrandId());

        this.pollsView.setBrandResults(poll.questions, poll.brandResults);
    }
}



// WEBPACK FOOTER //
// ./js/modules/polls_view.ts